// components/filePreview/renderers/DocRenderer.tsx
import { useEffect, useState } from "react";
import mammoth from "mammoth";
import { Box, CircularProgress } from "@mui/material";

export const DocRenderer = ({ arrayBuffer }: { arrayBuffer: ArrayBuffer }) => {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // cancelled flag prevents setState calls after the component unmounts,
    // which would trigger "Can't perform a React state update on an unmounted
    // component" warnings and act() warnings in tests.
    let cancelled = false;

    const convert = async () => {
      try {
        const result = await mammoth.convertToHtml({ arrayBuffer });
        if (!cancelled) setHtml(result.value);
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    convert();

    return () => {
      cancelled = true;
    };
  }, [arrayBuffer]);

  if (loading) return <CircularProgress />;

  return (
    <Box
      sx={{ maxHeight: "65vh", overflowY: "auto", px: 2, lineHeight: 1.8 }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};